module.exports = __webpack_public_path__ + "img/lpp.14a1d276.jpg";